






























































































import Vue from 'vue'
import Component from 'vue-class-component'
import DataTable from '@/components/shared/DataTable.vue'
import { CompletedAffiliateCompanyList } from '@/presentation/affiliated/CompletedAffiliateCompanyList'
import CorpModal from '@/components/affiliate/CorpModal.vue'
import BasicDialog from '@/components/commons/BasicDialog.vue'
import CorpWalletActivities from '@/components/affiliate/CorpWalletActivities.vue'
import AdjustWalletBalance from '@/components/affiliate/AdjustWalletBalance.vue'
import SearchComponent from '@/components/shared/SearchComponent.vue'

@Component({
  components: { AdjustWalletBalance, CorpWalletActivities, BasicDialog, CorpModal, DataTable, SearchComponent }
})
export default class CompletedAffiliatedList extends Vue {
  companies: CompletedAffiliateCompanyList = new CompletedAffiliateCompanyList(this.$confirm, this.$message)

  async reload () {
    await this.companies.initializeTableData()
    await this.companies.correctPageOverflow()
    const isSelectedCorpGone = this.companies.isCorpModalOpen && !this.companies.getCorp()
    if (isSelectedCorpGone) {
      this.companies.isCorpModalOpen = false
      this.$message.warning('변경으로 인해 항목이 현재 목록에서 벗어나 팝업을 닫았습니다.')
    }
  }

  changedSelect () {}

  async clickedSearch (clickedObject: Dictionary<any>) {
    const searchCategory: string = Object.keys(clickedObject)[0]
    const isCorpSearchCategory = searchCategory === 'corp_id' || searchCategory === 'corp_name'
    if (!isCorpSearchCategory) return
    this.companies.searchCategory = searchCategory
    this.companies.searchKeyword = clickedObject[searchCategory] || ''
    this.companies.page = 1
    await this.reload()
  }

  async onChangePage () {
    await this.reload()
  }

  async updateMemo () {
    await this.companies.updateMemo()
    await this.reload()
    this.companies.isCorpMemoModalOpen = false
  }

  async closeCorpModal () {
    this.companies.isCorpModalOpen = false
  }

  async created () {
    this.companies.statusFormField.status = 20
    await this.reload()
  }
}
